import { render, staticRenderFns } from "./MindoAsside.vue?vue&type=template&id=40f6e04a&"
import script from "./MindoAsside.vue?vue&type=script&lang=js&"
export * from "./MindoAsside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports